import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import FloatingContact from "@/components/FloatingContact";
import ExitIntentPopup from "@/components/ExitIntentPopup";
import VisitTracker from "@/components/VisitTracker";

export default function SiteLayout() {
  return (
    <div className="App grain min-h-screen relative">
      <Header />
      <main className="relative z-[2]">
        <Outlet />
      </main>
      <Footer />
      <FloatingContact />
      <ExitIntentPopup />
      <VisitTracker />
    </div>
  );
}
